module.exports = __webpack_public_path__ + "static/blur-mtg_clb-fd42fd8c9ea7fd5f53c4df257f27f58a.jpg";